interface EmployeeLike {
  id?: string;
  firstName?: string | null;
  lastName?: string | null;
  name?: string | null;
  avatarColor?: string | null;
}

interface Props {
  employee: EmployeeLike;
  size?: number;
}

// Backend will eventually expose `avatarColor` per employee
// (see docs/PLANNING_BACKEND_CHANGES.md). Until then every avatar is neutral.
const GRAY_FALLBACK = '#94a3b8';

function getInitials(e: EmployeeLike): string {
  if (e.firstName || e.lastName) {
    const initials = `${(e.firstName ?? '')[0] ?? ''}${(e.lastName ?? '')[0] ?? ''}`.toUpperCase();
    return initials || '?';
  }
  const parts = (e.name ?? '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

function getLabel(e: EmployeeLike): string {
  if (e.firstName || e.lastName) {
    return `${e.firstName ?? ''} ${e.lastName ?? ''}`.trim();
  }
  return e.name ?? 'Mitarbeiter';
}

export function EmployeeAvatar({ employee, size = 32 }: Props) {
  const tone = employee.avatarColor ?? GRAY_FALLBACK;
  return (
    <div
      className="rounded-full grid place-items-center font-semibold text-white shrink-0"
      style={{
        width: size,
        height: size,
        background: tone,
        fontSize: size * 0.38,
      }}
      role="img"
      aria-label={getLabel(employee)}
    >
      {getInitials(employee)}
    </div>
  );
}
